import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { styled } from '@mui/material/styles';
const CustomCardContent = styled(CardContent)(({ theme }) => ({
  '&:last-child': {
    paddingBottom: 0,
  },
}));
export default function CardLayout({
  backgroundColor = "#FFFFFF",
  marginBottom,
  margin,
  height,
  color = "#C3C9EE",
  position,
  padding = "0px",
  cursor,
  width,
  marginTop,
  borderRadius = "16px",
  boxShadow = "none",
  backgroundImage,
  fontSize,
  background,
  border,
  handleSubmit,
  cardContent,
  ...props
}) {

  return (
    <Card
      sx={{
        backgroundColor,
        marginBottom,
        margin,
        height,
        color,
        position,
        padding,
        cursor,
        width,
        marginTop,
        borderRadius,
        boxShadow,
        backgroundImage,
        fontSize,
        background,
        border,
        fontFamily: "DM Sans",
      }}
      onClick={handleSubmit}
      {...props}
    >
      <CustomCardContent sx={{paddingBottom:'0px'}}>
        <Typography variant="body1" component="div">
          {cardContent}
        </Typography>
      </CustomCardContent>
    </Card>
  );
}
